module.exports = __webpack_public_path__ + "img/144.d48e20e7.jpg";